import { Menu } from "react-bulma-components";
import Link from "next/link";
import { Fragment } from "react";
import Icon from "../Icon";

const LoopByJobs = ({ jobs }) => {
	jobs;
};
const CompanyMenu = ({ companies = null, jobsByCompany = {}, selectedComp, selectedJob }) => {
	return (
		<Menu>
			<Menu.List>
				<Link href={`/companies/new`} passHref>
          <Menu.List.Item>
            <Icon icon="plus" />Create a New Company
          </Menu.List.Item>
        </Link>
				{companies?.map(company => (
					<Menu.List.Item
						href={`/companies/admin/${company.id}`}
						key={company.id}
						active={!selectedJob && selectedComp == company.id}
					>
						<Menu.List title={company.name} key={company.id}>
							<Link href={`/companies/${company.id}/new-job`} passHref>
								<Menu.List.Item>
									<Icon icon="plus" />New job
								</Menu.List.Item>
							</Link>
							{jobsByCompany[company.id]?.map(job => (
								<Link href={`/companies/admin/${company.id}/${job.id}`} passHref key={job.id}>
									<Menu.List.Item active={selectedJob == job.id}>
										{selectedJob == job.id ? job.headline : job.headline}
									</Menu.List.Item>
								</Link>
							))}
						</Menu.List>
					</Menu.List.Item>
				))}
			</Menu.List>
		</Menu>
	);
};

export default CompanyMenu;
